import type { UserRole } from '@/types'

interface PagePermission {
  endpoint: string
  path: string
  prefix?: boolean
}

const adminPermissions: PagePermission[] = [
  { endpoint: 'tasks_new', path: '/admin/tasks/new', prefix: true },
  { endpoint: 'label_templates', path: '/admin/settings/label-templates', prefix: true },
  { endpoint: 'code_structures', path: '/admin/settings/code-structures', prefix: true },
  { endpoint: 'ka_generation', path: '/admin/ka-generation', prefix: true },
  { endpoint: 'label_editor', path: '/admin/label-editor', prefix: true },
  { endpoint: 'nomenclature', path: '/admin/nomenclature', prefix: true },
  { endpoint: 'shipments', path: '/admin/shipments', prefix: true },
  { endpoint: 'ka_templates', path: '/admin/ka-templates', prefix: true },
  { endpoint: 'contractors', path: '/admin/contractors', prefix: true },
  { endpoint: 'infrastructure', path: '/admin/infrastructure', prefix: true },
  { endpoint: 'advanced', path: '/admin/sidebar-settings', prefix: true },
  { endpoint: 'advanced', path: '/admin/advanced', prefix: true },
  { endpoint: 'metadata', path: '/admin/metadata', prefix: true },
  { endpoint: 'settings', path: '/admin/settings', prefix: true },
  { endpoint: 'tasks', path: '/admin/tasks', prefix: true },
  { endpoint: 'dashboard', path: '/admin' },
]

const workerPermissions: PagePermission[] = [
  { endpoint: 'shipments', path: '/worker/shipments', prefix: true },
  { endpoint: 'tasks', path: '/worker/tasks', prefix: true },
]

function definitions(role: UserRole): PagePermission[] {
  return role === 'worker' ? workerPermissions : adminPermissions
}

export function endpointForPath(pathname: string, role: UserRole): string | null {
  const match = definitions(role).find((item) =>
    item.prefix ? pathname === item.path || pathname.startsWith(`${item.path}/`) : pathname === item.path,
  )
  return match?.endpoint ?? null
}

export function firstAllowedPath(role: UserRole, allowed: string[]): string | null {
  const preferred = role === 'worker'
    ? ['tasks', 'shipments']
    : [
        'dashboard',
        'nomenclature',
        'tasks',
        'tasks_new',
        'shipments',
        'metadata',
        'ka_templates',
        'ka_generation',
        'contractors',
        'settings',
        'label_templates',
        'label_editor',
        'infrastructure',
        'advanced',
        'code_structures',
      ]
  const endpoint = preferred.find((item) => allowed.includes(item))
  if (!endpoint) return null
  return definitions(role).find((item) => item.endpoint === endpoint)?.path ?? null
}
